// @ts-check
import dinLight from '../fonts/300.js';
import dinMedium from '../fonts/500.js';

/** @type {import('../../../pdf-design-system/useTheme').BottlebooksPDFTheme["theme"]} */
const theme = {
  space: { 1: '1mm', 2: '2mm', 3: '4mm', 4: '1.5rem', 5: '2rem' },
  colors: { primary: '#999', onPrimary: 'white' },
  components: {
    Text: {
      base: { ...dinLight },
      default: { fontSize: 6.5, lineHeight: 7.8 / 6.5 },
      small: { fontSize: 6, lineHeight: 1 },
      medium: { ...dinMedium, fontSize: 6.5, lineHeight: 7.8 / 6.5 },
      large: { fontSize: 9, lineHeight: 12 / 9 },
      largeMedium: { ...dinMedium, fontSize: 9, lineHeight: 12 / 9 },
    },
    Title: {
      base: { ...dinMedium, textTransform: 'uppercase' },
      default: {
        fontSize: 12,
        lineHeight: 1,
        // marginTop: 14.4 - 12,
        // marginBottom: 12 - 14.4,
      },
      medium: {
        fontSize: 14,
        lineHeight: 1.3,
      },
      large: {
        fontSize: 18,
        lineHeight: 1.3,
      },
      larger: {
        fontSize: 24,
        lineHeight: 1,
      },
      largest: {
        fontSize: 36,
        lineHeight: 1,
      },
    },
  },
};

export default theme;
